/* global previews, data */
import copyPasteBannerCanvas from '../../../../common/preview/copy-paste-banner-canvas';
import {
  FIELD_TYPE_TEXT,
  FIELD_TYPE_MULTI_LINE_TEXT,
  FIELD_TYPE_PRODUCT_IMAGE,
  FIELD_TYPE_BACKGROND_THEME_IMAGE,
  FIELD_TYPE_RECTANGLE,
  FIELD_TYPE_CIRCLE,
  FIELD_TYPE_LINE,
  FIELD_TYPE_ADDITIONAL_HTML_TABLE
} from '../../../constants/type-fields-of-template';
import parseText from '../../../../common/preview/parse-text';
import {DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES, DEFAULT_TEXT_FIELD_PROPERTIES} from '../additional-fields';
import { addAddField, pasteTable } from '../additional-fields';
import {pasteImage} from "../../../services/helpers";
import store from '../../../store'
import { addProductImage } from '@frontend/group/modules/copy-paste-object/fields/product-image';
import {moveToStart} from "@frontend/utils";
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ELEMENT_ID,
  MULTI_LINE_PREFIX_ID
} from '@frontend/constants/templates-field-prefixes';

const getScopePage = () => ShowPageScopeCollector.get(['updateLayoutChanges']);

const TEXT_PREFIXES = [
  ADDITIONAL_MULTI_LINE_TEXT_FIELD_PREFIX_ELEMENT_ID,
  MULTI_LINE_PREFIX_ID
];

let state = {
    selectedInstance: null
};
let scope = {};

const DEFAULT_ADD_PARAMS = {
    hasUsersOrder: true,
    bringToFront: true
};

function initSelectTemplate() {
    $(document).on('click', '.canvas-container, .actions-grid', function () {
        if ($(this).find('#magick-eraser-canvas')) {
            return;
        }
        const $templateItemContainer = $(this).closest('.template-item');
        const instanceId = $templateItemContainer.data('instance');
        setSelectedInstance(instanceId);
    })

    $(document).on('click', function(event) {
      const activeObject = window.previews
        .map(({ canvas }) => canvas.getActiveObject())
        .find(obj => obj);

      if (  
          $(event.target).closest('.canvas-container').length 
          || String(event.target.className).includes('template-name-canvas')
          || event.target.closest('[data-action="copy"], [data-action="paste"]')
          || activeObject
        ) {
          return;
        }
        state.selectedInstance = null;
    })

    setDefaultSelectedInstance()
}

export function setSelectedInstance(instanceId) {
  if (!scope?.previews) return;

  const $templateItem = $(`[data-instance=${instanceId}]`);

  $('.template-name-canvas').css('font-weight', 'normal');
  $templateItem.find('.template-name-canvas').css('font-weight', 'bold');

  if (window.isDisplayBuilder) {
    $('.grid-stack-item').css({
      border: 'none',
      borderColor: 'transparent',
    });
  } else {
    $('.grid-stack-item').css('border-color', '#e1e1e1');
    $templateItem.find('.grid-stack-item').css('border-color', '#209c86');
  }

  state.selectedInstance = previews.find(preview => preview.id === instanceId) || null;

  store.commit('layout/SET_SELECTED_INSTANCE', state.selectedInstance);

  copyPasteBannerCanvas.setScope({ canvas: state?.selectedInstance?.canvas });
}

function setDefaultSelectedInstance () {
    const firstInstance = store.getters['layout/currentPagePreviews'][0]
    setSelectedInstance(firstInstance?.id)
}

function setScope(data = {}) {
    scope = { ...scope, ...data };
}

function findObjectByNameAndType(name, type, instanceId) {
    const canvasData = scope.canvas_data[instanceId];
    const templateInstance = canvasData.templateInstance;
    const preview = state.selectedInstance;
    const objects = preview.canvas.getObjects();

    const field = templateInstance.getFirstFieldByNameAndType(name, type);

    if (!field) return null;

    return objects.find(obj => +obj.fieldId === field?.id);
}

async function pasteAdditionalField({ object, id, text }) {
    const canvas = state.selectedInstance.canvas;

    if (!text && !object) return;

    const getShadowProps = (obj) => ({
        shadow: obj?.shadow || undefined,
        outlineShadow: obj?.outlineShadow || undefined,
        mirrorShadow: obj?.mirrorShadow || undefined,
        ovalShadow: obj?.ovalShadow || undefined,
    });

    let type = object?.fieldType;

    if (!object) {
        type = type || FIELD_TYPE_MULTI_LINE_TEXT;
    }

    let customFieldName = object?.fieldName;

    // Use absolute coordinates if available (from multi-select), otherwise use regular coordinates
    const offsetX = object?.absoluteLeft !== undefined ? object.absoluteLeft : object?.left;
    const offsetY = object?.absoluteTop !== undefined ? object.absoluteTop : object?.top;
    const capitalize = (value = '') => value.charAt(0).toUpperCase() + value.slice(1);
    const toNumericValue = (value) => {
        if (typeof value === 'number' && !Number.isNaN(value)) return value;
        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (!trimmed.length) return null;
            const parsed = parseFloat(trimmed);
            return Number.isNaN(parsed) ? null : parsed;
        }
        return null;
    };
    const getScaleValue = (obj, axisKey) => {
        const directScale = toNumericValue(obj?.[axisKey]);
        if (directScale !== null && directScale !== undefined) {
            return directScale;
        }
        return toNumericValue(obj?.[`real${capitalize(axisKey)}`]) ?? 1;
    };
    const getScaledDimension = (obj, dimensionKey) => {
        const preScaledKey = `scaled${capitalize(dimensionKey)}`;
        const preScaledValue = toNumericValue(obj?.[preScaledKey]);
        if (preScaledValue !== null && preScaledValue !== undefined) {
            return preScaledValue;
        }

        const baseValue = toNumericValue(obj?.[dimensionKey]) ?? toNumericValue(obj?.[`original${capitalize(dimensionKey)}`]);
        if (baseValue === null || baseValue === undefined) {
            return null;
        }
        const scale = dimensionKey === 'width'
            ? getScaleValue(obj, 'scaleX')
            : getScaleValue(obj, 'scaleY');
        return baseValue * scale;
    };
    const getStrokeWidth = (obj) => toNumericValue(obj?.strokeWidth) ?? 0;
    const isObjectTransfer = Boolean(object?.isObjectTransfer || object?.transferTargetTopRight);
    const getTemplateScaleFactor = (obj) => {
        const sourceTemplateWidth = obj?.sourceTemplateWidth;
        const sourceTemplateHeight = obj?.sourceTemplateHeight;
        const targetCanvas = state.selectedInstance?.canvas;
        const targetTemplateWidth = targetCanvas?.width;
        const targetTemplateHeight = targetCanvas?.height;

        if (!sourceTemplateWidth || !sourceTemplateHeight || !targetTemplateWidth || !targetTemplateHeight) {
            return 1;
        }

        const sourceAspectRatio = sourceTemplateWidth / sourceTemplateHeight;
        const targetAspectRatio = targetTemplateWidth / targetTemplateHeight;

        return sourceAspectRatio > targetAspectRatio
            ? targetTemplateWidth / sourceTemplateWidth
            : targetTemplateHeight / sourceTemplateHeight;
    };

    if (window.textFieldCopy) {
      const names = canvas.getObjects()
        .filter(obj => TEXT_PREFIXES.some(prefix => obj.element_id?.startsWith(prefix)))
        .map(obj => obj.name ?? obj.templateField?.name);

      customFieldName = generateLayerName(object?.name, names);
      delete window.textFieldCopy;
    }

    switch (type) {
        case FIELD_TYPE_TEXT:
        case FIELD_TYPE_MULTI_LINE_TEXT: {
            const defaultProperties = type === FIELD_TYPE_TEXT ? DEFAULT_TEXT_FIELD_PROPERTIES : DEFAULT_MULTI_LINE_TEXT_FIELD_PROPERTIES;
            await addAddField(
              type,
              id,
              {
                text,
                ...(object ? {
                    ...defaultProperties,
                    _color: object.fontColor ? object.fontColor : defaultProperties._color,
                    text: object.text,
                    _font: object.fontFamily ? object.fontFamily : defaultProperties._font,
                    _fontsize: object.fontSize ? object.fontSize : defaultProperties._fontsize,
                    _width: object.width ? object.width : defaultProperties._width,
                    _alignment: object.textAlign ? object.textAlign : defaultProperties._alignment,
                    _offset_x: offsetX,
                    _offset_y: offsetY,
                    name: customFieldName,
                    _styles: object.styles,
                    shadow: object?.shadow,
                    outlineShadow: object?.outlineShadow,
                } : {})
              },
              DEFAULT_ADD_PARAMS
            );

            break;
        }
        case FIELD_TYPE_BACKGROND_THEME_IMAGE:
            // For pasting, we need to preserve the visual size of the image
            // The visual size is: scaledWidth = width * scaleX, scaledHeight = height * scaleY
            // When the image loads, it may have different base dimensions, so we pass
            // the scaledWidth/scaledHeight to calculate the correct scale on render
            { const imgScaleX = object.realScaleX ?? object.scaleX ?? 1;
            const imgScaleY = object.realScaleY ?? object.scaleY ?? 1;
            const scaledWidth = object.scaledWidth ?? (object.width * imgScaleX);
            const scaledHeight = object.scaledHeight ?? (object.height * imgScaleY);
            const imageWidth = toNumericValue(object.width) ??
              toNumericValue(object.originalWidth) ??
              toNumericValue(object.scaledWidth);
            const imageHeight = toNumericValue(object.height) ??
              toNumericValue(object.originalHeight) ??
              toNumericValue(object.scaledHeight);

            await addAddField(
              type,
              id,
              {
                ...object,
                width: imageWidth,
                height: imageHeight,
                additional_background_images: object.src,
                add_bk_img_offset_x: offsetX,
                add_bk_img_offset_y: offsetY,
                // Pass the original scale values
                add_bk_img_scale: imgScaleX,
                add_bk_img_scale_y: imgScaleY,
                // Pass the visual dimensions for proper scaling calculation
                pasteScaledWidth: isObjectTransfer ? scaledWidth : undefined,
                pasteScaledHeight: isObjectTransfer ? scaledHeight : undefined,
                add_bk_img_opacity: object.opacity,
                add_bk_img_flipX: object.flipX,
                add_bk_img_flipY: object.flipY,
                add_bk_img_angle: object.angle,
                name: customFieldName,
                ...getShadowProps(object)
              },
              {
                ...DEFAULT_ADD_PARAMS,
                pasteObject: true,
              }
            );

            break; }

        case FIELD_TYPE_PRODUCT_IMAGE:
            await addProductImage(
              {
                scope,
                state,
                instanceId: id,
                copyObject: object,
                name: customFieldName,
                transferTargetTopRight: object.transferTargetTopRight || null,
              },
              DEFAULT_ADD_PARAMS
            );

            break;
        case FIELD_TYPE_CIRCLE:
        case FIELD_TYPE_RECTANGLE: {
            const scaleX = getScaleValue(object, 'scaleX');
            const scaleY = getScaleValue(object, 'scaleY');
            const templateScaleFactor = isObjectTransfer ? 1 : getTemplateScaleFactor(object);
            const sourceScaledWidth = getScaledDimension(object, 'width');
            const sourceScaledHeight = getScaledDimension(object, 'height');
            const scaledWidth = sourceScaledWidth !== null && sourceScaledWidth !== undefined
              ? sourceScaledWidth * templateScaleFactor
              : null;
            const scaledHeight = sourceScaledHeight !== null && sourceScaledHeight !== undefined
              ? sourceScaledHeight * templateScaleFactor
              : null;
            const strokeWidth = getStrokeWidth(object);

            const widthWithStroke =
              scaledWidth !== null && scaledWidth !== undefined ? scaledWidth + strokeWidth : null;
            const heightWithStroke =
              scaledHeight !== null && scaledHeight !== undefined ? scaledHeight + strokeWidth : null;
            const bakedScaleX = 1;
            const bakedScaleY = 1;

            if (type === FIELD_TYPE_RECTANGLE) {
                const cornerRadius = toNumericValue(object?.rx) ?? toNumericValue(object?.ry) ?? 0;
                const corners = object?.corners ? JSON.stringify(object.corners) : undefined;
                // Get fill type and gradient for gradient fills
                const fillType = object?.fillType || 'solid';
                const gradient = object?.gradient ? (typeof object.gradient === 'string' ? object.gradient : JSON.stringify(object.gradient)) : undefined;

                await addAddField(
                  type,
                  id,
                  {
                    _fill_color: typeof object.fill === 'string' ? object.fill : (object.fill?.colorStops?.[0]?.color || '#000000'),
                    _offset_x: offsetX,
                    _offset_y: offsetY,
                    _scaleX: bakedScaleX,
                    _scaleY: bakedScaleY,
                    _stroke_color: object.stroke,
                    _thickness: strokeWidth,
                    _opacity: object.opacity,
                    _radius: cornerRadius,
                    _corner_radius: cornerRadius,
                    _angle: object.angle,
                    _corners: corners,
                    _height: heightWithStroke !== null ? heightWithStroke : undefined,
                    _width: widthWithStroke !== null ? widthWithStroke : undefined,
                    _order: object.order,
                    _fill_type: fillType,
                    _gradient: gradient,
                    originalId: object.id,
                    name: customFieldName,
                    ...getShadowProps(object)
                  },
                  DEFAULT_ADD_PARAMS
                );
            } else {
                const circleDiameter = Math.min(
                  ...[scaledWidth, scaledHeight]
                    .filter((value) => value !== null && value !== undefined)
                );
                const radius = Number.isFinite(circleDiameter)
                  ? circleDiameter / 2
                  : (
                    (
                      toNumericValue(object?.radius) ??
                      toNumericValue(object?.rx) ??
                      toNumericValue(object?.ry) ??
                      150
                    ) * Math.max(scaleX, scaleY, 1) * templateScaleFactor
                  );

                // Get fill type and gradient for gradient fills
                const fillType = object?.fillType || 'solid';
                const gradient = object?.gradient ? (typeof object.gradient === 'string' ? object.gradient : JSON.stringify(object.gradient)) : undefined;

                await addAddField(
                  type,
                  id,
                  {
                    _fill_color: typeof object.fill === 'string' ? object.fill : (object.fill?.colorStops?.[0]?.color || '#000000'),
                    _offset_x: offsetX,
                    _offset_y: offsetY,
                    _scaleX: bakedScaleX,
                    _scaleY: bakedScaleY,
                    _stroke_color: object.stroke,
                    _thickness: strokeWidth,
                    _opacity: object.opacity,
                    _radius: radius,
                    _height: heightWithStroke !== null ? heightWithStroke : undefined,
                    _width: widthWithStroke !== null ? widthWithStroke : undefined,
                    _order: object.order,
                    _angle: object.angle,
                    _fill_type: fillType,
                    _gradient: gradient,
                    originalId: object.id,
                    name: customFieldName,
                    ...getShadowProps(object)
                  },
                  DEFAULT_ADD_PARAMS
                );
            }

            break;
        }
        case FIELD_TYPE_LINE: {
            const strokeWidth = toNumericValue(object.lineThickness) ?? getStrokeWidth(object);
            const templateScaleFactor = isObjectTransfer ? 1 : getTemplateScaleFactor(object);
            const serializedLineLength = toNumericValue(object.lineLength);
            const sourceScaledWidth = getScaledDimension(object, 'width');
            const sourceScaledHeight = getScaledDimension(object, 'height');
            const scaledWidth = sourceScaledWidth !== null && sourceScaledWidth !== undefined
              ? sourceScaledWidth * templateScaleFactor
              : null;
            const scaledHeight = sourceScaledHeight !== null && sourceScaledHeight !== undefined
              ? sourceScaledHeight * templateScaleFactor
              : null;
            let lineCoords = serializedLineLength !== null
              ? [0, 0, serializedLineLength * templateScaleFactor, 0]
              : object.coords;

            if (serializedLineLength === null && Array.isArray(object.coords) && object.coords.length === 4) {
                const [x1, y1, x2, y2] = object.coords.map((coord) => toNumericValue(coord) ?? 0);
                const isHorizontal = Math.abs(x2 - x1) >= Math.abs(y2 - y1);

                if (isObjectTransfer && isHorizontal && scaledWidth !== null && scaledWidth !== undefined) {
                    lineCoords = [0, 0, Math.max(scaledWidth - strokeWidth, 0), 0];
                } else if (isObjectTransfer && scaledHeight !== null && scaledHeight !== undefined) {
                    lineCoords = [0, 0, 0, Math.max(scaledHeight - strokeWidth, 0)];
                } else if (!isObjectTransfer && templateScaleFactor !== 1) {
                    lineCoords = object.coords.map((coord) => (toNumericValue(coord) ?? 0) * templateScaleFactor);
                }
            }
            const normalizedLineWidth = Array.isArray(lineCoords) && lineCoords.length === 4
              ? Math.hypot(
                (toNumericValue(lineCoords[2]) ?? 0) - (toNumericValue(lineCoords[0]) ?? 0),
                (toNumericValue(lineCoords[3]) ?? 0) - (toNumericValue(lineCoords[1]) ?? 0),
              )
              : null;

            await addAddField(
              type,
              id,
              {
                _stroke_color: object.stroke,
                _thickness: strokeWidth,
                _offset_x: offsetX,
                _offset_y: offsetY,
                _opacity: object.opacity,
                _order: object.order,
                _coords: lineCoords,
                _width: normalizedLineWidth,
                _angle: toNumericValue(object.lineAngle) ?? object.angle ?? 0,
                name: customFieldName,
              },
              DEFAULT_ADD_PARAMS
            );
            break;
        }
        case FIELD_TYPE_ADDITIONAL_HTML_TABLE:
            await pasteTable(
              {
                currentInstanceId: id,
                currentPreview: state.selectedInstance,
                tableData: object.tableData,
                html_table_data: object.html_table_data,
                field_id: object.field_id,
                _offset_x: offsetX,
                _offset_y: offsetY,
                _angle: object.angle || 0,
                name: customFieldName,
              },
              DEFAULT_ADD_PARAMS
            );
            break;
        default:
            break;
    }
}


export async function pasteObjectField({ object, id, text } = data) {
    /*if (object && false) {
        const obj = findObjectByNameAndType(object.name, object.fieldType, id);

        if (obj) {
            switch (object.fieldType) {
                case FIELD_TYPE_TEXT:
                case FIELD_TYPE_MULTI_LINE_TEXT:
                    const { text, styles } = parseText(object.text, object.fontColor);

                    obj.set({
                        styles,
                        fontColor: object.fontColor,
                        text,
                        fontFamily: object.fontFamily,
                        fontSize: object.fontSize,
                    });

                    scope.handleObjectMoving({ target: obj });
                    scope.handleTextChange({ target: obj });

                    break;
                case FIELD_TYPE_BACKGROND_THEME_IMAGE:
                    const newImage = await scope.replaceBackgroundImage(object.src, obj.id, id);
                    newImage.set({
                        scaleX: object.scaleX,
                        scaleY: object.scaleY,
                    });

                    scope.handleObjectMoving({ target: newImage });

                    newImage.canvas.renderAll();
                    break;
                case FIELD_TYPE_CIRCLE:
                case FIELD_TYPE_RECTANGLE:
                    obj.set({
                        fill: object.fill,
                        scaleX: object.scaleX,
                        scaleY: object.scaleY,
                    });

                    scope.handleObjectMoving({ target: obj });

                    break;
            }

            obj.canvas.renderAll();

            return;
        }
    }*/

    await pasteAdditionalField({ object, id, text });
}

function confirmPaste() {
  return Swal.fire({
    title: 'Similar to the last item pasted. Paste anyway?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    icon: 'warning'
  })
}

let pasteHandlerInitialized = false;

function init(data) {
    setScope(data);

    initSelectTemplate();

    copyPasteBannerCanvas.init();
    if (pasteHandlerInitialized) return;
    pasteHandlerInitialized = true;
    copyPasteBannerCanvas.on('paste', async function (event) {
        if (!state.selectedInstance) return;

        // Skip paste if Generate Image modal is open
        const $generateImageModal = $('#generateImageModal');
        if ($generateImageModal.length && $generateImageModal.hasClass('show')) {
            return;
        }

        if (!window.pastedData) window.pastedData = [];
        if (window.pastedData.length) {
            let found = window.pastedData.find(({instanceId, e}) => instanceId === state.selectedInstance.canvas.instance_id && JSON.stringify(e) === JSON.stringify(event));
            if (!found && event?.text) {
              found = window.pastedData.find(({instanceId, e}) => instanceId === state.selectedInstance.canvas.instance_id && e?.text === event.text);
            }
            if (found) {
              let value = await confirmPaste();

              if (!value || value.isConfirmed === false) {
                return;
              }
            }
        }
        
        const $loadingOverlay = $('.loadingOverlay');

        $loadingOverlay.fadeIn();
        $('.loadingOverlay-text').html('Loading Layout...');
        
        const { theme } = state.selectedInstance.data;
        const { customer_id, id: templateId } = state.selectedInstance.template;
        const instanceId = state.selectedInstance.canvas.instance_id;
        const canvas = state.selectedInstance.canvas;
        window.pastedData.push({instanceId: instanceId, e: event});

        // Check for text paste (no object or files)
        if ((!event.object || typeof event.object === 'number') && !event.files.length) {
            const activeObject = canvas.getActiveObject();

            // If we have a selected text/multiline text field, update it
            if (activeObject && (
                activeObject.id?.includes('text_') || 
                activeObject.id?.includes('multi_line') ||
                activeObject.id?.includes('add_text_') ||
                activeObject.id?.includes('add_multi_line_text_') ||
                activeObject.id?.includes('additional_multi_line_text')
            )) {
                const { updateLayoutChanges } = getScopePage();
                const { text, styles } = parseText(event.text, activeObject.fontColor);
                activeObject.set({
                    text,
                    styles
                });
                canvas.renderAll();
                updateLayoutChanges(
                    canvas.instance_id,
                    `${activeObject.element_id}`,
                    text
                );

                // update styles from pasted text
                updateLayoutChanges(
                    canvas.instance_id,
                    `${activeObject.element_id}_styles`,
                    styles
                );
                $('.btn-save-changes').prop("disabled", false);
            } else {
                let defaultFont = 'Proxima-Nova-Semibold';
                let textFont = '';
                if (state.selectedInstance.template && state.selectedInstance.template?.fields && Array.isArray(state.selectedInstance.template.fields)) {
                    const fields = state.selectedInstance.template.fields;
                    let extraFont = '';
                    for(let i = 0; i < fields.length; i++) {
                        let opts = JSON.parse(fields[i].options);
                        if (fields[i].element_id.includes('_text_') && opts?.Font) {
                            textFont = opts.Font;
                            break;
                        }
                        
                        if (opts?.Font) {
                            extraFont = opts.Font;
                            break;
                        }
                    }
                    
                    if (!textFont) textFont = extraFont;
                }
                
                // No text field selected - create new one
                await addAddField(
                    FIELD_TYPE_MULTI_LINE_TEXT,
                    instanceId,
                    { text: event.text, _font: textFont || defaultFont }
                );
            }

            $loadingOverlay.fadeOut();

            return;
        }
        
        for (let i = 0; i < event.files.length; i++) {
            
            const file = event.files[i];
            const fileDataUrl = event.dataUrls[i];
            const fileUrl = await pasteImage(file, { customer_id, theme, templateId, fileDataUrl });
            let src = `${location.origin}/share?file=${fileUrl}`
            
            await addAddField(
              FIELD_TYPE_BACKGROND_THEME_IMAGE,
              instanceId, 
              { additional_background_images: src }
            );
        }

        if (!event.object && !event.objects) {
            $loadingOverlay.fadeOut();
            return;
        }

        // Handle multiple objects paste
        if (event.isMultiple && event.objects && Array.isArray(event.objects)) {
            // Apply a common offset to all objects so they don't overlap with originals
            // but maintain their relative positions to each other
            const PASTE_OFFSET = 50; // pixels to offset from original position

            // Calculate scale factor if pasting to a different template size
            const firstObject = event.objects[0];
            const sourceTemplateWidth = firstObject?.sourceTemplateWidth;
            const sourceTemplateHeight = firstObject?.sourceTemplateHeight;
            const targetTemplateWidth = canvas?.width;
            const targetTemplateHeight = canvas?.height;

            let positionScaleFactor = 1;
            if (sourceTemplateWidth && sourceTemplateHeight && targetTemplateWidth && targetTemplateHeight) {
                // Check if templates are different sizes
                if (sourceTemplateWidth !== targetTemplateWidth || sourceTemplateHeight !== targetTemplateHeight) {
                    const sourceAspectRatio = sourceTemplateWidth / sourceTemplateHeight;
                    const targetAspectRatio = targetTemplateWidth / targetTemplateHeight;

                    if (sourceAspectRatio > targetAspectRatio) {
                        positionScaleFactor = targetTemplateWidth / sourceTemplateWidth;
                    } else {
                        positionScaleFactor = targetTemplateHeight / sourceTemplateHeight;
                    }
                }
            }

            // Separate Product Images from other objects since they have special positioning
            const productImages = event.objects.filter(obj => obj.fieldType === 'Product Image');
            const otherObjects = event.objects.filter(obj => obj.fieldType !== 'Product Image');

            // Calculate the minimum coordinates to find how much we need to shift
            // to keep the leftmost/topmost elements visible
            let minX = Infinity, minY = Infinity;
            for (const obj of otherObjects) {
                const left = (obj.absoluteLeft ?? obj.left ?? 0) * positionScaleFactor;
                const top = (obj.absoluteTop ?? obj.top ?? 0) * positionScaleFactor;
                minX = Math.min(minX, left);
                minY = Math.min(minY, top);
            }

            // Simple adjustment: shift everything so the leftmost/topmost element
            // is at the margin, plus a small offset to avoid overlap with originals
            const margin = 20;
            let adjustX = PASTE_OFFSET;
            let adjustY = PASTE_OFFSET;

            // If any element would be outside the left edge, shift right
            if (minX + adjustX < margin) {
                adjustX = margin - minX;
            }
            // If any element would be outside the top edge, shift down
            if (minY + adjustY < margin) {
                adjustY = margin - minY;
            }

            // Paste non-Product Image objects with the same adjustment to maintain relative positions
            for (const objectData of otherObjects) {
                // Check if field name already exists in destination canvas
                if (objectData?.fieldName) {
                    canvas.getObjects().forEach(function (o) {
                        if (o.name === objectData.fieldName) {
                            objectData.fieldName = null;
                        }
                    })
                }

                // Scale coordinates and apply the same adjustment to all objects
                if (objectData.absoluteLeft !== undefined) {
                    objectData.absoluteLeft = (objectData.absoluteLeft * positionScaleFactor) + adjustX;
                }
                if (objectData.absoluteTop !== undefined) {
                    objectData.absoluteTop = (objectData.absoluteTop * positionScaleFactor) + adjustY;
                }
                if (objectData.left !== undefined) {
                    objectData.left = (objectData.left * positionScaleFactor) + adjustX;
                }
                if (objectData.top !== undefined) {
                    objectData.top = (objectData.top * positionScaleFactor) + adjustY;
                }

                await pasteObjectField({
                    id: state.selectedInstance?.id || null,
                    object: objectData,
                    text: objectData.text
                });
            }

            // Paste Product Images (they use their own positioning system)
            for (const objectData of productImages) {
                if (objectData?.fieldName) {
                    canvas.getObjects().forEach(function (o) {
                        if (o.name === objectData.fieldName) {
                            objectData.fieldName = null;
                        }
                    })
                }

                await pasteObjectField({
                    id: state.selectedInstance?.id || null,
                    object: objectData,
                    text: objectData.text
                });
            }
        } else {
            // Handle single object paste (backward compatibility)
            if (event?.object?.fieldName) {
                canvas.getObjects().forEach(function (o) {
                    //there's no need to update field name if that field name already exists in the destination canvas
                    if (o.name === event.object.fieldName) {
                        event.object.fieldName = null;
                    }
                })
            }

            await pasteObjectField({
                id: state.selectedInstance?.id || null,
                ...event
            });
        }

        $loadingOverlay.fadeOut();
    });
}

function generateLayerName(baseName, existingNames = []) {
  const match = baseName.match(/^(.*?)(\d+)?$/);
  let prefix = match[1].trim();
  let numPart = match[2];

  let nextNum = numPart ? parseInt(numPart, 10) + 1 : 1;
  const zeroPadLength = numPart ? numPart.length : 0;

  // search for unique name
  let newName;
  do {
    let numStr = zeroPadLength
      ? String(nextNum).padStart(zeroPadLength, '0')
      : String(nextNum);
    newName = prefix ? `${prefix} ${numStr}`.replace(/\s+/, ' ') : numStr;
    nextNum++;
  } while (existingNames.includes(newName));

  return newName;
}

export default {
    init,
}
